import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Correct from './Correct';
import Finish from './Finish';
import Wrong from './Wrong';
import '../firstaid.css';

export default function Results({
  choice,
  step,
  setStep,
  setChoice,
  answeredQuestion,
  setAnsweredQuestion,
  totalSteps,
  category,
  resetProgress,
  options = [],
}) {
  const { t } = useTranslation();
  const renderContent = (selection) => {
    switch (selection) {
      case t(options[0]):
        return (
          <Correct
            setChoice={setChoice}
            setStep={setStep}
            answeredQuestion={answeredQuestion}
            setAnsweredQuestion={setAnsweredQuestion}
            totalSteps={totalSteps}
          />
        );
      case t(options[1]):
        return <Wrong step={step} setStep={setStep} setChoice={setChoice} totalSteps={totalSteps} />;
      case 'Finish':
        return <Finish category={category} resetProgress={resetProgress} />;
      default:
        return null;
    }
  };
  return <div className="results__container">{renderContent(choice)}</div>;
}

Results.defaultProps = {
  answeredQuestion: null,
};

Results.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  choice: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  setChoice: PropTypes.func.isRequired,
  category: PropTypes.string.isRequired,
  answeredQuestion: PropTypes.string,
  setAnsweredQuestion: PropTypes.func.isRequired,
  resetProgress: PropTypes.func.isRequired,
};
